import React from "react";
import { CollectionUtils } from "andculturecode-javascript-core";
import { DataTable } from "components/tables/data-table/data-table";
import { EmptyText } from "components/empty-text/empty-text";
import { Heading, HeadingSize } from "components/typography/heading/heading";
import { t } from "utilities/localization/t";
import "./add-bulk-group-users-preview.scss";
import { GroupUserUploadResultRecord } from "../../../../../../../models/view-models/groups/group-user-upload-result-record";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface AddBulkGroupUsersPreviewProps {
    validGroupUsers: GroupUserUploadResultRecord[];
    invalidGroupUsers: GroupUserUploadResultRecord[];
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constant
// ------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME: string = "add-bulk-group-users-preview";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const AddBulkGroupUsersPreview: React.FC<AddBulkGroupUsersPreviewProps> = ({
    validGroupUsers,
    invalidGroupUsers,
}) => {
    return (
        <div className={CSS_CLASS_NAME}>
            <div>
                <Heading size={HeadingSize.XSmall}>{t("validUsers")}</Heading>{" "}
                {CollectionUtils.hasValues(validGroupUsers) ? (
                    <DataTable>
                        <thead>
                            <tr>
                                <th className="name">{t("name")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {validGroupUsers.map((groupUser, idx) => (
                                <tr key={`valid-${idx}`}>
                                    <td className="email">{groupUser.email}</td>
                                </tr>
                            ))}
                        </tbody>
                    </DataTable>
                ) : (
                    <EmptyText>{t("noValidUsers")}</EmptyText>
                )}
            </div>
            <div>
                <Heading size={HeadingSize.XSmall}>{t("notValidUsers")}</Heading>
                {CollectionUtils.hasValues(invalidGroupUsers) ? (
                    <DataTable>
                        <thead>
                            <tr>
                                <th className="name">{t("name")}</th>
                                <th className="errors">{t("errors")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invalidGroupUsers.map((groupUsers, idx) => (
                                <tr key={`invalid-${idx}`}>
                                    <td className="email">{groupUsers.email}</td>
                                    <td className="errors">
                                        {groupUsers.errors?.map((errorMessage) => (
                                            <div>{errorMessage}</div>
                                        ))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </DataTable>
                ) : (
                    <EmptyText table>{t("noInvalidUsers")}</EmptyText>
                )}
            </div>
        </div>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { AddBulkGroupUsersPreview };

// #endregion Exports
